import styled, { css } from 'styled-components';

import { font, themeValue, withSiteTheme } from '../../../../config/css';

const DocumentBrowseCardMetaTitleTheme = {
  default: css`
    display: block;
    letter-spacing: ${themeValue('letterSpacing', 'md')};
    text-transform: uppercase;

    svg {
      margin: 0.6rem 0 0;

      &.atk {
        height: 1.4rem;
        width: 3.8rem;

        .background {
          fill: ${themeValue('colors', 'cork')};
        }
      }

      &.cco {
        height: 1.6rem;
        width: 6.7rem;

        path {
          fill: ${themeValue('colors', 'cork')};
        }
      }

      &.cio {
        height: 1.5rem;
        margin-bottom: 0.2rem;
        width: 5.7rem;
      }
    }
  `,
  atk: css`
    color: #1f1f1f;
    font: ${font('sm', 'xsm', 'pnb')};

    .quick-view-card & {
      color: #1f1f1f;
      font: ${font('xsm', 'xsm', 'pnb')};
      margin-bottom: 0.4rem;
    }
  `,
  cco: css`
    color: ${themeValue('colors', 'black')};
    font: ${font('sm', 'sm', 'pnr')};
    letter-spacing: ${themeValue('letterSpacing', 'xxxlg')};

    .quick-view-card & {
      color: ${themeValue('colors', 'black')};
      font: ${font('sm', '1.17', 'pnr')};
      letter-spacing: ${themeValue('letterSpacing', 'xxxlg')};
      margin-bottom: 0.4rem;
    }
  `,
  cio: css`
    color: ${themeValue('colors', 'squirrel')};
    font: ${font('xsm', 'xsm', 'pnb')};

    .quick-view-card & {
      color: ${themeValue('colors', 'cork')};
      line-height: 1.2rem;
    }
  `,
};

const DocumentBrowseCardMetaTitle = styled.span.attrs({
  className: 'document-browse-card__meta-title',
})`
  ${withSiteTheme(DocumentBrowseCardMetaTitleTheme)}
`;

export default DocumentBrowseCardMetaTitle;
